import { useEffect } from 'react';

const IOS_STORE_URL     = 'https://apps.apple.com/app/6748879356';
const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.makemoneystudio.isf';

const AppStorePage = () => {
  useEffect(() => {
    const ua = navigator.userAgent || '';
    const isIOS     = /iPad|iPhone|iPod/i.test(ua) && !window.MSStream;
    const isAndroid = /android/i.test(ua);

    // ticker 파라미터 추출 (/appStore?ticker=AAPL)
    const params = new URLSearchParams(window.location.search);
    const ticker = params.get('ticker');
    const appScheme = ticker ? `mmstudio://?ticker=${ticker}` : 'mmstudio://';
    const fallbackPath = ticker ? `/stockDetail/${ticker}` : '/stockMain';

    if (isIOS) {
      const timer = setTimeout(() => {
        window.location.replace(IOS_STORE_URL);
      }, 1500);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearTimeout(timer);
          window.location.replace(fallbackPath);
        }
      }, { once: true });

      window.location.href = appScheme;

    } else if (isAndroid) {
      const intentUrl = ticker ? `mmstudio://open?&ticker=${ticker}` : 'mmstudio://open';
      window.location.replace(intentUrl);

    } else {
      window.location.replace(fallbackPath);
    }
  }, []);

  return null;
};

export default AppStorePage;
